
import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Calculator from "@/components/Calculator";
import EnvSetupGuide from "@/components/EnvSetupGuide";

const Index = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-1">
        {/* Calculator Section */}
        <section id="calculator" className="py-12 md:py-16">
          <div className="container px-4 md:px-6 mx-auto">
            <div className="flex flex-col items-center text-center space-y-4 mb-8">
              <h2 className="text-3xl md:text-4xl font-bold tracking-tighter">
                Calculate Your Newsletter Revenue Potential
              </h2>
              <p className="text-xl text-muted-foreground max-w-2xl">
                Use our calculator to see how much additional revenue you could generate with an optimized newsletter marketing strategy.
              </p>
            </div>
            
            <EnvSetupGuide />
            <Calculator />
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default Index;
